import { createContext } from "react";

export const timerContext = createContext();